import { api } from '@/core/api/';

const URL = 'api/provider/locationservice';

export const getRequestinfo = (companyId) =>
  api.get(`${URL}/requestinfo`, { params: { companyId } });

export const getInitFilters = () => api.get(`${URL}/initfilters`);

export const search = (payload) =>
  api.get(`${URL}/search`, {
    params: {
      ...payload,
    },
  });

export const saveLocationService = (payload) =>
  api.post(`${URL}/savelocationservice`, payload);

export const getDetailInfo = (locationFiscalYearId) =>
  api.get(`${URL}/detail/${locationFiscalYearId}`);

export const addLocationServiceContact = (contact, locationId, companyId) =>
  api.post(
    `${URL}/addLocationServiceContact?locationId=${locationId}&companyId=${companyId}`,
    contact
  );

export const editLocationServiceContact = (contact, locationId) =>
  api.put(
    `${URL}/editLocationServiceContact?locationId=${locationId}`,
    contact
  );

export const deleteLocationServiceContact = (contactId) =>
  api.delete(`${URL}/deleteLocationServiceContact/${contactId}`);

export const editGeneralInformation = (generalInformation) =>
  api.put(`${URL}/editGeneralInformation`, {
    ...generalInformation,
  });

export const updateLocationServiceNPI = (payload) =>
  api.put(`${URL}/npi`, {
    ...payload,
  });

export const getlocationServices = (payload) =>
  api.get(`${URL}/locationServices`, {
    params: {
      ...payload,
    },
  });

export const deactivateLocationService = (locationId) =>
  api.put(`${URL}/deactivatelocationservice/${locationId}`);

export const activateLocationService = (locationId) =>
  api.put(`${URL}/activatelocationservice/${locationId}`);

export const hasactivespecialists = (locationId) =>
  api.get(`${URL}/hasactivespecialists/${locationId}`);
